import React from "react";
import { isBrowser } from "react-device-detect";
import { openHomeCareOrderSamplingModal, openLabOrderSamplingModal, openRejectLabOrderModal } from "../../../../../redux/actions/modals";
import { useDispatch } from "react-redux";
import SafeCallComponent from "../LabOrderItem/children/SafeCallComponent";

const LabOrderWaitingForCallActions = (props) => {
  const dispatch = useDispatch();

  let order_type = props.order.order_type;
  order_type = order_type ?? 'lab';
  const lab_text = "تعیین زمان نمونه‌گیری";
  const home_care_text = "تعیین زمان اعزام پزشک/پرستار";
  let button_title = order_type === 'lab' ? lab_text : home_care_text;
  return (
    <>
      <div className={isBrowser ? "flex-column waiting-for-price-buttons" : "flex-column waiting-for-price-buttons-mobile"}>
        <button
          className="btn btn-small btn-success btn-accept margin-bottom-5"
          onClick={() => {
            order_type === 'lab' ? dispatch(openLabOrderSamplingModal(props.order)) : dispatch(openHomeCareOrderSamplingModal(props.order));
          }}
        >
            {button_title}
        </button>
        <SafeCallComponent order={props.order} />
        {/* <button
          className="btn btn-small btn-outline-black margin-bottom-5"
          onClick={() => {
            dispatch(openRejectLabOrderModal(props.order));
          }}
        >
          رد سفارش
        </button> */}
      </div>
    </>
  );
};

export default LabOrderWaitingForCallActions;
